module.exports = ["A","B","AB","O","Unknown"]


//////////////////
// WEBPACK FOOTER
// ./src/data/bloodTypes.json
// module id = 1175
// module chunks = 0